// @flow
// ----------------------------------------------------------------------
// <copyright file='Izenda.FilterItem.js' company='Izenda'>
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * Filter Item component
 */

import classnames from 'classnames';
import { ACCESS_RIGHT } from 'logic/data/Izenda.AuthorizationConstants';
import CONSTANTS from 'logic/data/Izenda.FilterDetailsConfigConstants';
import FilterPopover from './Izenda.FilterPopover';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import typeof { DOMElement } from 'react';
import GridLayout from 'share/components/controls/Izenda.GridLayout';
import OverflowText from 'share/components/controls/Izenda.OverflowText';
import connect from 'share/enhancers/Izenda.Connect';
import 'share/utils/Izenda.StringUtilities';
import { observable } from 'mobx';

@connect()
export default class FilterItem extends Component {
  static propTypes = {
    itemData: PropTypes.object.isRequired,
    fieldStore: PropTypes.object,
    viewMode: PropTypes.bool,
    isLazyLoading: PropTypes.bool,
    index: PropTypes.number
  };

  // Indicates if the popover is visible
  @observable visible: boolean = false;

  /**
   * Set ref for filter dom
   */
  setDOMNode = (ele: DOMElement) => {
    this.filterItemDom = ele;
  };

  /**
   * On click on filter
   */
  onClickFilter = () => {
    const {
      accessPriority,
      fieldStore: { reportFilters },
      itemData
    } = this.props;
    const isDisablePopover = accessPriority === ACCESS_RIGHT.Locked;
    reportFilters.setConfigModeToField(itemData.fieldDetails);
    this.visible = !isDisablePopover;
  };

  /**
   * Close popover
   */
  closePopover = () => {
    this.visible = false;
  };

  render() {
    const props = this.props;
    const itemData = props.itemData || {};
    const fieldDetails = itemData.fieldDetails || {};
    const filterInfo = itemData.filterInfo;
    const isRequiredFilter = fieldDetails.required;
    const {
      fieldStore,
      fieldStore: {
        reportFilters: {
          configField: { fieldDetails: configFieldDetails }
        }
      },
      isLazyLoading,
      viewMode,
      index,
      updateCascadingValue
    } = this.props;

    const label = fieldDetails.alias;
    const operator =
      filterInfo.operator.name === CONSTANTS.OPERATOR_GROUP.UNKNOWN
        ? CONSTANTS.DEFAUFT_OPERATOR_LABEL
        : filterInfo.operator.name;

    const mode =
      CONSTANTS.SHOW_MODE_OPERATOR.indexOf(filterInfo.operator.key) > -1
        ? (fieldDetails.operatorSetting === CONSTANTS.SELECT_SETTINGS.MULTIPLE || fieldDetails.operatorSetting === CONSTANTS.SELECT_SETTINGS.MULTIPLE_COMMA || fieldDetails.operatorSetting === CONSTANTS.SELECT_SETTINGS.MULTIPLE_NEWLINE)
          ? ` - ${CONSTANTS.SELECT_TEXT.MULTIPLE}`
          : ` - ${CONSTANTS.SELECT_TEXT.SINGLE}`
        : '';
    const defaultToolTip = `${label} - ${operator}${mode}`;
    const tooltipOperator = fieldDetails.commonFilterRequired
      ? `${defaultToolTip} \n ${props.localization.getText('DASHBOARD_TOOLTIP_REQUIRED_FILTER')}`
      : defaultToolTip;

    const filterTextClasses = classnames('filter-alias', { 'required-before': isRequiredFilter });
    const classes = classnames('filter-control view-mode', {
      selected: configFieldDetails === fieldDetails && this.visible
    });

    return (
      <GridLayout.Col className='izenda-FilterItemPill u_noPaddingAll' cols='3'>
        <div className='filter-wrapper' ref={this.setDOMNode} onClick={this.onClickFilter}>
          <div className={classes}>
            <OverflowText tooltip={tooltipOperator} className={filterTextClasses}>
              <span>{label}&nbsp;</span>
              <span className='operator'>{String.format(' - {0}{1}', operator, mode)}</span>
            </OverflowText>
            {this.visible && configFieldDetails === fieldDetails && (
              <FilterPopover
                updateCascadingValue={updateCascadingValue}
                closePopover={this.closePopover}
                anchor={this.filterItemDom}
                fieldStore={fieldStore}
                itemData={itemData}
                isLazyLoading={isLazyLoading}
                index={index}
                viewMode={viewMode}
              />
            )}
          </div>
        </div>
      </GridLayout.Col>
    );
  }
}



// WEBPACK FOOTER //
// ./ui/modules/Reports/FilterProperty/Izenda.FilterItem.js